
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"27","viewBox":"0 0 26 27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"y":".5","width":"26","height":"26","rx":"13","fill":"#3F4A58"}}),_c('path',{attrs:{"d":"M12.43 6.417c-.34 0-.63.24-.694.573l-.237 1.214a5.654 5.654 0 00-1.59.915l-1.166-.401a.709.709 0 00-.844.315l-1.068 1.851a.71.71 0 00.148.89l.934.812c-.048.298-.08.602-.08.914 0 .313.032.616.08.915l-.934.812a.71.71 0 00-.148.89l1.068 1.85c.17.295.523.427.844.317l1.165-.4c.472.386 1.01.692 1.591.912l.237 1.215a.707.707 0 00.694.573h2.139c.34 0 .63-.24.694-.573l.237-1.215a5.656 5.656 0 001.591-.914l1.165.401c.32.11.674-.021.844-.316l1.068-1.852a.708.708 0 00-.148-.888l-.934-.812c.049-.299.08-.602.08-.915a5.67 5.67 0 00-.08-.914l.934-.812a.71.71 0 00.148-.89L19.1 9.034a.709.709 0 00-.844-.318l-1.165.402a5.656 5.656 0 00-1.59-.914l-.237-1.214a.707.707 0 00-.695-.573H12.43zm1.07 4.25a2.833 2.833 0 110 5.667 2.833 2.833 0 010-5.667z","fill":"#fff"}})])
          )
        }
      }
    